<template>
    <b-card>
        <h4 class="mb-2">
            Participant visit Status
            <div class="float-right">
                <b-button size="sm" variant="success" @click="downloadExcel()" v-if="$can('view', 'event_booths')">
                    <feather-icon
                    icon="DownloadIcon"
                    class="mr-50"
                    /><span>Export Excel</span>
                </b-button>
            </div>
        </h4>
        <div class="row">
            <div style="border: 1px solid #b4b7bd; padding: 10px; overflow: auto; width:100%; height: 250px; ; margin: 0 10px">
            <!-- List of names -->
            <div v-for="(item, index) in participants" :key="index">
              {{ item.name.split(',')[0] }} - {{item.company}} => ({{ item.booth_visit }}) [{{ item.total }}]
            </div>
          </div>
        </div>
    </b-card>
</template>

<script>
import { BCard,BButton } from 'bootstrap-vue'
import * as XLSX from 'xlsx';

export default {
  components: {
    BCard,
    BButton,
    XLSX
  },
  data() {
    return {
    }
  },
  props: {
    participants: {
        type: Array,
        required: true,
    },
    booths:{
        type: Array,
        required: true,
    }
    },
  methods: {
    downloadExcel() {
      let excelRows = []

      this.participants.map(row => {

        let currentObj = {
            name: (row.name) ? row.name : '-',
            company: (row.company) ? row.company : '-',
            total_booth_visited: (row.total) ? row.total : '-',
            booth_visit: (row.booth_visit) ? row.booth_visit : '-',
        }

        excelRows.push(currentObj)

      })

      let excelHeaders = []

      excelRows.forEach((row, index) => {
        for(const [objIndex, [key, value]] of Object.entries(Object.entries(row))) {

          if(index == 0) {
            const words = key.split("_");

            let colName = []

            words.forEach((word) => {
              colName.push(word[0].toUpperCase() + word.substring(1))
            })

            excelHeaders.push(colName.join(" "))
          }

          if(value == '' || value === null) {
            excelRows[index][key] = '-'
          }
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(excelRows)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Participant Visit Status")
      XLSX.utils.sheet_add_aoa(worksheet, [excelHeaders], { origin: "A1" });

      XLSX.writeFile(workbook, "booth_participant_report_" + Date.now() + ".xlsx", { compression: true });

      this.isLoading = false
    },
    },
  }
</script>